import { render, staticRenderFns } from "./DuoFeatures.vue?vue&type=template&id=0b61eb83&"
import script from "./DuoFeatures.vue?vue&type=script&lang=js&"
export * from "./DuoFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports